const RupiahConvert = (value) => {
  const convertToRupiah = () => {
    let rupiah = '';
    const convert = value.toString().split('').reverse().join('');

    for (var i = 0; i < convert.length; i++)
      if (i % 3 === 0) rupiah += convert.substr(i, 3) + '.';

    return rupiah
      .split('', rupiah.length - 1)
      .reverse()
      .join('');
  };

  const withLableRupiah = () => {
    return `Rp${convertToRupiah()}`;
  };

  const convertToNumber = () => {
    return parseInt(value.replace(/,.*|[^0-9]/g, ''), 10);
  };

  const getWithComa = () => {
    const convertToNumber = parseFloat(value);
    const checkConvert =
      convertToNumber === NaN ? 0 : parseFloat(String(convertToNumber));

    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(checkConvert);
  };

  const getWithComaLabel = () => {
    return `Rp${getWithComa(value)}`;
  };

  return {
    detail: withLableRupiah(), // => Rp1.000.000
    default: convertToNumber(), // => 1000000
    withoutLabel: convertToRupiah(), // => 1.000.000
    getWithComaLabel: getWithComaLabel(), // => Rp1.000.000,00
    getWithComa: getWithComa(),
  };
};

export default RupiahConvert;
